import ApiLayout, {
    GridSize,
    LayoutAlignment,
    LayoutDirection,
    LayoutDistribution,
    LayoutSizingMode,
    Padding
} from "../api/model/snapshots/layers/Layout";

import { VariableReference } from "../api/model/variables/Variables";

import Model from "./model";

export default class Layout extends Model {
    direction?: LayoutDirection;
    padding?: Padding;
    gap: number;
    sizingMode?: LayoutSizingMode;
    itemAlignment?: LayoutAlignment;
    distribution?: LayoutDistribution;
    alignment?: LayoutAlignment;
    variableReferences?: VariableReference[];

    // Figma grid
    columnCount?: number;
    columnGap?: number;
    rowCount?: number;
    rowGap?: number;
    columnSizes?: GridSize[];
    rowSizes?: GridSize[];

    constructor({
        direction,
        padding,
        gap,
        sizingMode,
        itemAlignment,
        distribution,
        alignment,
        variableReferences,
        columnCount,
        columnGap,
        rowCount,
        rowGap,
        columnSizes,
        rowSizes
    }: ApiLayout) {
        super();
        this.direction = direction;
        this.padding = padding;
        this.gap = gap;
        this.sizingMode = sizingMode;
        this.alignment = alignment;
        this.itemAlignment = itemAlignment;
        this.distribution = distribution;
        this.variableReferences = variableReferences;

        // Figma grid
        this.columnCount = columnCount;
        this.columnGap = columnGap;
        this.rowCount = rowCount;
        this.rowGap = rowGap;
        this.columnSizes = columnSizes;
        this.rowSizes = rowSizes;
    }

    override toObject() {
        return {
            direction: this.direction,
            padding: this.padding,
            gap: this.gap,
            sizingMode: this.sizingMode,
            alignment: this.alignment,
            itemAlignment: this.itemAlignment,
            distribution: this.distribution,
            variableReferences: this.variableReferences,

            // Figma grid
            columnCount: this.columnCount,
            columnGap: this.columnGap,
            rowCount: this.rowCount,
            rowGap: this.rowGap,
            columnSizes: this.columnSizes,
            rowSizes: this.rowSizes
        };
    }
}
